/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBbsContentInfoRespVo
 */
export interface GetBbsContentInfoRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof GetBbsContentInfoRespVo
     */
    id?: number;
    /**
     * 标题
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    title?: string;
    /**
     * 作者（按当前语言取中/韩文名）
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    author?: string;
    /**
     * 内容
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    content?: string;
    /**
     * 分类 ID，关联 BBS 分类表
     * @type {number}
     * @memberof GetBbsContentInfoRespVo
     */
    categoryId?: number;
    /**
     * 分类名称(中)
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    categoryCnName?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    createTime?: string;
    /**
     * 更新时间
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    updateTime?: string;
    /**
     * 发布时间
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    publishTime?: string;
    /**
     * 员工id
     * @type {number}
     * @memberof GetBbsContentInfoRespVo
     */
    staffId?: number;
    /**
     * 员工名称
     * @type {string}
     * @memberof GetBbsContentInfoRespVo
     */
    staffName?: string;
}

/**
 * Check if a given object implements the GetBbsContentInfoRespVo interface.
 */
export function instanceOfGetBbsContentInfoRespVo(value: object): value is GetBbsContentInfoRespVo {
    return true;
}

export function GetBbsContentInfoRespVoFromJSON(json: any): GetBbsContentInfoRespVo {
    return GetBbsContentInfoRespVoFromJSONTyped(json, false);
}

export function GetBbsContentInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBbsContentInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'author': json['author'] == null ? undefined : json['author'],
        'content': json['content'] == null ? undefined : json['content'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryCnName': json['categoryCnName'] == null ? undefined : json['categoryCnName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'publishTime': json['publishTime'] == null ? undefined : json['publishTime'],
        'staffId': json['staffId'] == null ? undefined : json['staffId'],
        'staffName': json['staffName'] == null ? undefined : json['staffName'],
    };
}

export function GetBbsContentInfoRespVoToJSON(json: any): GetBbsContentInfoRespVo {
    return GetBbsContentInfoRespVoToJSONTyped(json, false);
}

export function GetBbsContentInfoRespVoToJSONTyped(value?: GetBbsContentInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'author': value['author'],
        'content': value['content'],
        'categoryId': value['categoryId'],
        'categoryCnName': value['categoryCnName'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'publishTime': value['publishTime'],
        'staffId': value['staffId'],
        'staffName': value['staffName'],
    };
}

